import React, { useState, useEffect, useCallback, useContext } from 'react';
import { GrammarFillin } from './GrammarInputs.jsx';
import StartButton from '../../buttons/StartButton.jsx';
import { API_URL } from '../../../config.js';
import { useAuth } from "react-oidc-context";
import { GameContext } from '../../../GameContext.jsx';

const PluralsQuiz = ({ onResultUpdate, shouldEnd, onEndComplete }) => {
  const auth = useAuth();
  const token = auth.user?.access_token;
  const [isGameActive, setIsGameActive] = useState(false);
  const [isAnswerSelected, setIsAnswerSelected] = useState(true);
  const [userInput, setUserInput] = useState('');
  const [question, setQuestion] = useState('');
  const [correctAnswer, setCorrectAnswer] = useState('');
  const [answerResult, setAnswerResult] =useState(false);
  const [pluralArticle, setArticle] = useState('');
  const { selectedLanguage, languageData, learnedWords, updateLearnedList, loadLanguageData, grammarQuestionsList, 
      learnedGrammarList, loadGrammarQuestions, loadUsersLearnedGrammar, updateLearnedGrammarList } = useContext(GameContext);
  const selectedGrammarExercise = 'plurals';
  console.log("selectedGrammarExercise: ", selectedGrammarExercise);

  const handleGameStart = useCallback(async(started) => {
    if (started) {
  console.log('Starting new plurals session')
  console.log(selectedLanguage)
  try {
    const initResponse = await fetch(`${API_URL}/api/new-grammar-exercise`, {
      method: 'POST',
      credentials: 'include',
      mode: 'cors',
      headers: {'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`},
      body: JSON.stringify({ vocab_list: languageData,
          selected_grammar_exercise: selectedGrammarExercise }),
    });
    const initData = await initResponse.json();
    console.log("Plurals Quiz initialized:", initData);
    loadUsersLearnedGrammar(initData.learnedGrammarList);
    loadGrammarQuestions(initData.grammarQuestionsList);
    console.log('length of Plurals file = ' + initData.grammarQuestionsList.length)

    setIsGameActive(true);
    setIsAnswerSelected(false);
    onResultUpdate({
      feedback: ''
    });
    const wordList = initData.grammarQuestionsList;
    const learnedWordList = initData.learnedGrammarList;
    await fetchNewWord(wordList,learnedWordList);
  } catch (error) {
    console.error('Error starting plurals quiz:', error);
    console.log('Error name:', error.name);
    console.log('Error message:', error.message);
    onResultUpdate({
      feedback: 'An error occurred while evaluating your answer. Please try again.'
    });
  }
  setIsAnswerSelected(false);
}else {
  await endGame();
}
});

const fetchNewWord = async (wordList = null, learnedWordList = null) => {
  console.log("Starting the plurals game process");
  console.log("selected grammar exercise = "+ selectedGrammarExercise)
  const listToUse = wordList || grammarQuestionsList;
  const learnedListToUse = learnedWordList || learnedGrammarList;
  console.log(listToUse.length)
  console.log(learnedGrammarList.length)
    try {
      const response = await fetch(`${API_URL}/api/generate-grammar-question`, {
        method: 'POST',
        credentials: 'include',
        headers: {'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ 
              selected_grammar_exercise: selectedGrammarExercise,
              selected_grammar_questions_list: listToUse,
              learned_grammar_list: learnedListToUse
            }),
      });
      if (!response.ok) {
        throw new Error('Failed to end game on server');
      }
      const data = await response.json();

      setIsAnswerSelected(false);
      setCorrectAnswer(data.generatedAnswer);
      setQuestion(data.generatedQuestion);
      setArticle(data.pluralArticle)
    } catch (error) {
        console.log('Error fetching plurals question:');
      }
  setUserInput('');
};

const handleInputChange = (e) => {
  setUserInput(e.target.value);
};

const handleAnswerSelected = useCallback(async (selected) => {
  console.log("Handling Answer...");
  console.log(selected)
  setIsAnswerSelected(true);

  try {
    const response = await fetch(`${API_URL}/api/process-grammar-fillin`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        userAnswer: selected,
        correctAnswer: correctAnswer,
        question: question,
        grammarExercise: selectedGrammarExercise, 
        selected_grammar_questions_list: grammarQuestionsList,
        learned_grammar_list: learnedGrammarList
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const result = await response.json();
    console.log("Evaluation result:", result);

    onResultUpdate({
      feedback: result.feedback
    });
    setUserInput('');
    setAnswerResult(result.got_answer_correct);

  } catch (error) {
    console.error('Error evaluating answer:', error);
  }

}, [selectedGrammarExercise, fetchNewWord, onResultUpdate]);

const endGame = useCallback(async () => {
  console.log("Ending the game process");
  if (!isGameActive) return;

  try {
    const response = await fetch(`${API_URL}/api/end-grammar-quiz`, {
      method: 'POST',
      credentials: 'include',
      headers: {'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        grammarExercise: selectedGrammarExercise, 
        learned_grammar_list: learnedGrammarList
      }),
    });
    if (!response.ok) {
      throw new Error('Failed to end game on server');
    }
    const data = await response.json();
    console.log("Verbs with preps result:", data);

    onResultUpdate({
      feedback: data.feedback,
      answersGiven: data.answersGiven
    });

  } catch (error) {
    console.error("Error ending game on server:", error);
  } finally {
    setIsGameActive(false);
    setUserInput('');
    onEndComplete();
    setIsAnswerSelected(true);
  }
}, [isGameActive, onResultUpdate, onEndComplete]);


  useEffect(() => {
    //used to fire when the quiz is switched to another grammar exercise
    if (shouldEnd) {
      console.log(`Running end game process for plurals`);
      endGame();
      onEndComplete();
    }
  }, [shouldEnd, onEndComplete]);

  const QuestionDisplay = ({ pluralArticle, question, displayAnswer, answerResult, correctAnswer }) => {
      const getColorClass = () => {
        if (answerResult && displayAnswer) return 'success';
        return 'secondary';
      };

      const getTextClass = () => {
        if (!answerResult && displayAnswer) return 'fw-bold fst-italic';
        return 'fw-bold';
      };

      return (
        <p className="fs-2 text-left mb-0">
          {pluralArticle}{" "}
          <span className={`text-${getColorClass()} ${getTextClass()}`}>{displayAnswer ? correctAnswer : "_____"}</span>
        </p>
      );
    };



return(

<div className="bg-light p-1 m-1 rounded">
  <div className="mb-1">
    <h5 className="mb-2">
          {isGameActive ? (
            <span className="custom-text-primary">Type the plural form of the following noun</span>
          ) : (
            <span className="custom-text-primary">Click Start to begin</span>
          )}
    </h5>
    <div style={{ marginBottom: '40px' }}></div>
    <h5 className="custom-text-standard-dark">{question}</h5>
    <div style={{ marginBottom: '20px' }}></div>
    <h5 className="mb-2">
      <QuestionDisplay 
            pluralArticle={pluralArticle}
            question={question}
            displayAnswer={isAnswerSelected}
            answerResult={answerResult}
            correctAnswer = {correctAnswer} />
          <div style={{ marginBottom: '40px' }}></div>
      <div style={{ marginBottom: '20px' }}></div>
    </h5>
    <GrammarFillin 
    onSubmit={() => handleAnswerSelected(userInput)}
    userInput={userInput}
    onInputChange={handleInputChange}
    isSubmitted={isAnswerSelected}
    />
    <div style={{ marginBottom: '40px' }}></div>
  </div>
    <div class="d-flex justify-content-between">
      <button className="btn btn-success custom-next-button btn-block mt-2 w-75" 
              type="button" 
              id="continueButton" 
              onClick={() => fetchNewWord()}    
              disabled={!isAnswerSelected || !isGameActive}>Continue</button>
        <StartButton
          onToggle={handleGameStart}
          id="grammarStartButton"  
          isStarted={isGameActive}
        />
    </div>
</div>
    

);

};

export default PluralsQuiz;